import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { format } from 'date-fns';
import { auth, db, collection, query, where, getDocs } from './firebase';
import './EditProfile.css';

export default function UserProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [streak, setStreak] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        setUser(currentUser);
        try {
          const q = query(
            collection(db, 'checkins'),
            where('userId', '==', currentUser.uid)
          );
          const querySnapshot = await getDocs(q);
          const entries = querySnapshot.docs.map(doc => {
            const data = doc.data();
            return {
              ...data,
              id: doc.id,
              dateOnly: format(new Date(data.timestamp), 'yyyy-MM-dd')
            };
          });
          
          // Calculate streak based on actual unique days
          let currentStreak = 0;
          if (entries.length > 0) {
            const uniqueDates = Array.from(new Set(entries.map(e => e.dateOnly)));
            currentStreak = uniqueDates.length;
          }
          setStreak(currentStreak);
        } catch (err) {
          setStreak(0);
        }
      }
      setLoading(false);
    };
    fetchUserData();
  }, []);

  // Update user name in Firebase Auth
  // const handleSaveProfile = async () => {
  //   if (!editName.trim()) {
  //     setError('Name cannot be empty');
  //     return;
  //   }
  //   setSaving(true);
  //   setError('');
  //   try {
  //     if (auth.currentUser) {
  //       await auth.currentUser.updateProfile({ displayName: editName });
  //       setUser({ ...auth.currentUser });
  //       setShowEditModal(false);
  //     }
  //   } catch (err) {
  //     setError('Failed to update name');
  //   }
  //   setSaving(false);
  // };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (loading) return <div className="profile-container">Loading...</div>;

  return (
    <div className="profile-container">
      <h2>User Profile</h2>
      {user && (
        <div className="profile-details">
          <div><strong>Name:</strong> <span>{user.displayName || 'N/A'}</span></div>
          <div><strong>Email:</strong> <span>{user.email}</span></div>
          <div><strong>Current Streak:</strong> <span>{streak} days</span></div>
        </div>
      )}
      <div className="profile-actions">
        <button className="edit-profile-btn" onClick={() => navigate('/edit-profile')}>
          Edit Profile
        </button>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
